import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { EmailPackage } from 'interfaces/email-package.model';

@Injectable()
export class EmailPackageProvider {

  constructor(
    public http: HttpClient,
    public storage: Storage) {}

  getPackages(): Promise<EmailPackage[]> {
    return this.storage.get("emailPackages").then(res => {
      if(res){
        return res.sort((epack1: EmailPackage, epack2: EmailPackage) => {
          return +new Date(epack2.created_at) - +new Date(epack1.created_at)
        });
      } else {
        return [];
      }
    });
  }

  createPackage(data, assetId: number): Promise<EmailPackage[]>{
    return this.getPackages().then((emailPackages: EmailPackage[]) => {
      const newPackage: EmailPackage = {
        id: Date.now(),
        email: data.email,
        created_at: new Date(Date.now()).getTime(),
        attachments: [assetId],
        size: data.attachmentSize
      };
      if(emailPackages){
        emailPackages.push(newPackage);
        return this.storage.set("emailPackages", emailPackages)
      } else {
        return this.storage.set("emailPackages", emailPackages);
      }
    });
  }

  updatePackage(emailPackage: EmailPackage): Promise<EmailPackage[]> {
    return this.getPackages().then((emailPackages: EmailPackage[]) => {
      if (!emailPackages || emailPackages.length === 0) {
        return null;
      }
      
      let newPackages: EmailPackage[] = emailPackages;
      const index = newPackages.findIndex(e => e.id == emailPackage.id);
      newPackages[index] = emailPackage;

      return this.storage.set("emailPackages", newPackages)
    }); 
  }

  updateAttachmentsPackage(id: number, assetId: number): Promise<EmailPackage[]> {
    return this.getPackages().then((emailPackages: EmailPackage[]) => {
      if (!emailPackages || emailPackages.length === 0) {
        return null;
      }

      const index = emailPackages.findIndex(emailPackage => emailPackage.id == id);
      if(index != -1){
        emailPackages[index].attachments.push(assetId);
      }
      
      return this.storage.set("emailPackages", emailPackages);
    });
  }

  deletePackage(id: number): Promise<EmailPackage[]>{
    return this.getPackages().then((emailPackages: EmailPackage[]) => {
      if (!emailPackages || emailPackages.length === 0) {
        return null;
      }
      let toKeep: EmailPackage[] = emailPackages.filter(e => e.id !== id);

      return this.storage.set("emailPackages", toKeep)
    }); 
  }

  deleteAssetInAllPackage(id: number) {
    return this.getPackages().then((emailPackages: EmailPackage[]) => {
      if (!emailPackages || emailPackages.length === 0) {
        return null;
      }
            
      emailPackages.forEach(emailPackage => {
        if(emailPackage.attachments.length > 0){
          const index = emailPackage.attachments.findIndex(attachmentId => attachmentId === id);
          if(index != -1){
            emailPackage.attachments.splice(index, 1);
          }
        }
      });
      
      return this.storage.set("emailPackages", emailPackages);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/email-package/email-package.ts